module.exports = __webpack_public_path__ + "img/chevron-left.9a69f480.svg";